import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";

// English fallbacks for this component's common_ns keys. The backend common_ns source
// (Google Sheet -> ContentTranslation) overrides these once the keys are seeded; ko/vi
// are served from there. Keeps the component self-sufficient without a local bundle.
const DEFAULTS = {
  "CONTACT_US_CENTER.TOOLBAR.PLACEHOLDER": "Enter a keyword...",
  "CONTACT_US_CENTER.COMMON.SEARCH": "Search",
};

/** Shared search toolbar for the information-board tabs — search by name (title). */
const BoardToolbar = ({ onSearch }) => {
  const [keyword, setKeyword] = useState("");
  const { t: translate } = useTranslation("common_ns", { useSuspense: false });
  const t = (key, options) =>
    translate(key, { defaultValue: DEFAULTS[key] ?? key, ...options });

  return (
    <div className="cuc-board-toolbar">
      <InputText
        className="cuc-search-input"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onSearch?.({ keyword })}
        placeholder={t("CONTACT_US_CENTER.TOOLBAR.PLACEHOLDER")}
      />
      <Button
        className="keduall-buttons button-filled-default-normal-primary text-white-txt keduall-typography heading-h6-semibold-600"
        label={t("CONTACT_US_CENTER.COMMON.SEARCH")}
        onClick={() => onSearch?.({ keyword })}
      />
    </div>
  );
};

export default BoardToolbar;
